var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('LoaderCircle',{staticClass:"h-8 w-8 animate-spin text-microsoft-blue-default mb-2"}),_c('p',{staticClass:"text-base text-neutral-gray-700"},[_vm._v(" "+_vm._s(_vm.loading)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }